//descriptionGeneral is mockup this value is fetched from wordpress


export const localDirections = [
  {
    id: 1,
    wordpressID: 250,
    wordpressKey: 'turismo',
    title: 'SECTOR TURISMO',
  },
  {
    id: 2,
    wordpressID: 132,
    wordpressKey: 'telecomunicaciones',
    title: 'Telecomunicaciones',
  },
  {
    id: 3,
    wordpressID: 134,
    wordpressKey: 'energía',
    title: 'Energía',
  },
  {
    id: 4,
    wordpressID: 133,
    wordpressKey: 'infraestructura',
    title: 'Infraestructura',
  },
  {
    id: 5,
    wordpressID: 134,
    wordpressKey: 'Servicios_Inversionista',
    title: 'Servicios al Inversionista',
  },
  {
    id: 6,
    wordpressID: 134,
    wordpressKey: 'Otros_Servicios_Inversionista',
    title: 'Otros servicios al inversionista',
  },

  {
    id: 7,
    wordpressID: 134,
    wordpressKey: 'empresaServicios',
    title: 'DIRECCIÓN GENERAL DE ALIANZAS PÚBLICO-PRIVADAS (DGAPP)',
  },
  {
    id: 8,
    wordpressID: 134,
    wordpressKey: 'TrámitesCine',
    title: 'Trámites Dirección General de Cine',
  },
]
